import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    TextField,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { AddBox, AddCircle, CheckBox, CheckBoxOutlineBlank, Delete, RemoveCircle, Save, Search } from '@mui/icons-material';

import { makeid, myTimestampToDate } from '../utils/ui_utils';
import { NumberInput } from '../components/NumberInput';



const newaward = {
    param_name: '',
    param_description: '',
}






export const CustomCowFilterParamDialog = forwardRef(({ event_id, reloadFn, t, add_param, edit_param }, ref) => {
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newaward })
    const [isEdited, setIsEdited] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [index, setIndex] = useState(-1)






    useImperativeHandle(ref, () => {
        return {
            onNew(list) {
                setCurElement({ ...newaward, id: makeid(6), order: list ? list.length + 1 : 1 })
                setIndex(-1)
                setIsNew(true)
                setIsEdited(false)
                setOpen(true);
            },
            onEdit(el, i, is_c) {
                console.log("IS CURRENT", is_c)
                setOpen(true);
                setIsNew(false)
                let _el = { ...newaward, ...el }
                setCurElement(_el)
                initData(is_c, el.id)
                setIndex(i)
                setIsEdited(false)
            }
        }
    })


    const handleClose = () => {
        setOpen(false);
    };


    const handleSave = () => {
        if (is_new) {
            add_param(curElement)
        } else {
            edit_param(curElement, index)
        }
        setOpen(false)
    }



    const onChangeHandler = (el) => {
        let { name, value, type } = el
        console.log(el)
        console.log("V", name, value, type)
        if (type === 'radio') {
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }
        } else if (type === 'list') {
            let _l = []
            if (curElement[name]) {
                _l = [...curElement[name]]
            }
            const k = _l.indexOf(value)
            if (k < 0) {
                _l.push(value)
            } else {
                _l.splice(k, 1)
            }
            value = _l
        } else if (type === 'checkbox') {
            value = el.checked
        } else if (type === 'number') {
            value = parseInt(value)
        }

        if (value !== undefined) {
            setCurElement({ ...curElement, [name]: value })
            setIsEdited(true)
        }
    }








    const initData = async (is_current, s_id) => {

    }







    return (
        <div>

            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth={true}>
                <DialogTitle>
                    Parametro personalizzato:  {curElement.param_name}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <NumberInput
                            value={curElement.order}
                            label={'ordine di visualizzazione'}
                            name="order"
                            onChangeHandler={onChangeHandler}
                            setCurElement={setCurElement}
                            setIsEdited={setIsEdited}
                        />
                        <TextField
                            margin="dense"
                            id="param_name"
                            label={'Nome'}
                            fullWidth
                            name="param_name"

                            variant="standard"
                            value={curElement.param_name}
                            onChange={(ev) => onChangeHandler(ev.target)}
                        />

                        <TextField
                            margin="dense"
                            id="param_description"
                            label={'descrizione'}
                            fullWidth
                            name="param_description"
                            variant="standard"
                            value={curElement.param_description}
                            onChange={(ev) => onChangeHandler(ev.target)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                    {isEdited &&
                        <Button key={'bs'} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" loading={isSaving} loadingpoint="start">Salva</Button>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
})



